// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"684":"17d3db74","815":"7dfdbb2d"}[chunkId] + ".chunk.js");